export default function getRandomArrayValues(arr, num) {
  return [...arr].sort(() => Math.random() - 0.5).slice(0, num);
}
